var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bs-wrapper no-power-box"},[_c('div',{staticClass:"content flex-col"},[_c('img',{staticClass:"img",attrs:{"src":require('../../assets/img/common/noPower.png'),"alt":""}}),_c('span',[_vm._v("暂无权限，无法查看")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }